import range from 'lodash/range'
import {Dropdown} from '@freckle/educator-materials/ts/components/dropdown'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {flatOptions} from '@freckle/educator-materials/ts/logic/dropdown'
import {gradeDropdown} from './grade-picker.module.scss'

type Props = {
  currentGrade: number | undefined | null
  onChangeGrade: (grade?: number | null) => void
}

export function GradePicker(props: Props) {
  const {t} = useSafeTranslation()
  const {currentGrade, onChangeGrade} = props

  const allGradesSelected = currentGrade === undefined || currentGrade === null
  const allGrades = t('GROWTH_PAGE_ALL_GRADES_OPTION_TEXT')

  const allGradesItem = {label: allGrades, value: allGrades}
  const gradeItems = range(0, 13).map(grade => ({
    label: t('DISPLAY_GRADE', {grade}),
    value: grade.toString()
  }))

  const menuItems = [allGradesItem, ...gradeItems]

  const value = allGradesSelected
    ? allGradesItem
    : {label: t('DISPLAY_GRADE', {grade: currentGrade}), value: currentGrade.toString()}

  return (
    <div className={gradeDropdown}>
      <div data-pii id="grade-picker-dropdown">
        <Dropdown
          labelText={t('GROWTH_PAGE_GRADE_PICKER_LABEL_TEXT')}
          value={value}
          handleChange={newValue => {
            if (newValue === null) {
              onChangeGrade(null)
            } else {
              onChangeGrade(newValue.value === allGrades ? null : parseInt(newValue.value, 10))
            }
          }}
          options={flatOptions<string>(menuItems)}
        />
      </div>
    </div>
  )
}
